import { techdocsPlugin } from '@backstage/plugin-techdocs';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';

// TechDocs pins both sidebars with `position: fixed` and offsets the table of
// contents from the viewport's right edge, so it drifts away from the article
// whenever the reader is narrower than the window (e.g. the entity Docs tab),
// leaving the article squeezed into the remaining space.
//
// Laying the main area out as a three-column grid keeps the sidebars fixed
// vertically, while their horizontal static position follows the grid: a
// fixed child of a grid container is aligned by `justify-self` within the
// container's content box. The breakpoint matches TechDocs' own desktop query.
const layoutCss = `
@media screen and (min-width: 76.25em) {
  .md-main__inner {
    display: grid;
    grid-template-columns: 16rem minmax(0, 1fr) 16rem;
  }
  .md-content {
    grid-column: 2;
    grid-row: 1;
    margin-left: 0;
    max-width: none;
  }
  .md-sidebar--secondary {
    right: auto;
    justify-self: end;
  }
}
`;

// Rendered into the TechDocs shadow root, so these rules reach the MkDocs DOM.
const TechDocsLayoutStyles = () => <style>{layoutCss}</style>;

export const TechDocsLayout = techdocsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'TechDocsLayout',
    location: TechDocsAddonLocations.Content,
    component: TechDocsLayoutStyles,
  }),
);
